import React from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import MaintenanceImg from './img/maintenance.png';
import './style.css';

const Maintenance = () => {
  const { t } = useTranslation();
  return (
    <div className="maintenance">
      <p>{t('maintenance.title')}</p>
      <img src={MaintenanceImg} alt="Maintenance" />
    </div>
  );
};

export default Maintenance;
